// 스토어 링크 단일 정본.
export const APP_STORE_URL =
  "https://apps.apple.com/kr/app/%EB%AA%A8%EB%91%90%EC%9D%98-%ED%85%8C%EC%8A%A4%ED%8A%B8-%EC%8B%AC%EB%A6%AC%ED%85%8C%EC%8A%A4%ED%8A%B8/id6779297168";

export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.simplesoft.modutest";
